export class DonutRangeModel  {
  range: number;
  color: string;
}
